import { MODAL_TYPES } from '../constants/modals';

export const isAfp = type => type === MODAL_TYPES.AFP;
